import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'a-texteditor',
  templateUrl: 'a-texteditor.component.html',
  styleUrls: ['a-texteditor.component.scss'],
})
export class ATextEditorComponent implements OnInit {

  @Input() isSubmitted = true;
  @Input() label = '';
  @Input() isOptional = false;
  @Input() control: any = new FormControl();
  @Output() onBlur = new EventEmitter<any>();
  
  initValue = null;
  editorFocused = false;
  editorControl: any = new FormControl();

  constructor() {
  }

  ngOnInit(): void {
    if (this.control.value) {
      this.initValue = this.control.value;
    }
  }

  focusIn(param) {
    this.editorFocused = param;
  }

  checkSave() {
    if (this.control.value !== this.initValue) {
      this.onBlur.emit();
      this.isSubmitted = true;
      this.initValue = this.control.value;
    }
  }

}
